import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// importing the course screen styles for stylings
import "../styles/CoursesScreen.css";

// importing course cards components for showing courses
import QuizeCards from "./components/CoursesCards";
import Cookies from "js-cookie";

import { getAllQuizesByStudent } from "../../../../services/quiz/quize";

export default function QuizeIndexScreen() {
	const [quizes, setQuizes] = useState([]);
	const navigate = useNavigate();

	const fetchQuizes = async () => {
		try {
			// Identity comes solely from the JWT on the server side (/quizzes/my-quizzes) -
			// no client-supplied studentId is sent or needed.
			const response = await getAllQuizesByStudent();
			if (response) {
				setQuizes(response);
			}
		} catch (error) {
			console.error("Error fetching quizzes:", error);
		}
	};

	useEffect(() => {
		fetchQuizes();
	}, []);

	const handleQuizClick = (quiz) => {
		if (quiz.isSubQuiz) {
			// Navigate to sub-quiz listing page for this quiz
			navigate(`/home/sub-quize?parentQuizId=${quiz.id}`);
		} else {
			// Open quiz question popup
			navigate(`/home/quiz-page?quizeId=${quiz.id}`);
		}
	};

	return (
		<div className='HomeContextContainer'>
			<h2 className='CoursesScreenHeading'>Music Quiz: Learn & Play!</h2>
			<div className='CoursesScreenCoursesList'>
				{quizes && quizes.length > 0 ? (
					quizes?.map((quiz) => (
						<div key={quiz.id} onClick={() => handleQuizClick(quiz)}>
							<QuizeCards
								id={quiz.id}
								serialNumber={quiz.id}
								title={quiz.title}
								courseDescription={quiz.courseDescription}
								thumbnail={quiz.imgURL || "https://courses.learningmusicanywhere.com/images/a4e8afcd-2598-46c2-b372-759dd00c575f_introduction-to-Music-1A.jpg"}
								isSubCourse={quiz.isSubCourse}
								isSubQuiz={quiz.isSubQuiz}
							/>
						</div>
					))
				) : (
					<div className="text-center bg-gray-100 text-gray-600 px-4 py-2 rounded-md inline-block mt-8">
						No quizzes found.
					</div>
				)}
			</div>
		</div>
	);
}
